import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { Props } from './types';

export default function DateCell({ plan }: Props) {
	const { formatDate } = useIntl();

	if (!plan?.statusChangedTimestamp) return null;

	return plan.statusChangedTimestamp ? (
		<Container>
			{formatDate(plan.statusChangedTimestamp * 1000, {
				year: 'numeric',
				month: 'short',
				day: '2-digit',
			})}
		</Container>
	) : null;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150', '12px'),
	paddingBottom: token('space.150', '12px'),
});
